import { errorNotify } from '@js/utilities/bugsnag.js'

function networkErrorMessage(store, error) {
    let translationErrorKey
    let errorMessage = error.message

    switch (error.response?.status) {
        case 500:
            translationErrorKey = 'errors.server'
            errorMessage ??= 'Server Error'
            break
        case 502:
            translationErrorKey = 'errors.gateway'
            errorMessage ??= 'Gateway Error'
            break
        case 504:
            translationErrorKey = 'errors.network'
            errorMessage ??= 'Network Error'
            break
        default:
            translationErrorKey = 'errors.fieldNetworkError'
            errorMessage ??= 'Unknown Error'
            break
    }

    const errorTranslation = store.state.global.$t(translationErrorKey)

    errorNotify(errorMessage, 'error', 'Network Error', { data: error.response })

    return errorTranslation
}

export { networkErrorMessage }
